import ProductFlagsDictionary from './ProductFlagsDictionary';

export type ProductFlagDictionaryKey = keyof typeof ProductFlagsDictionary;

export type ResolvedProductFlag = {
  key: ProductFlagDictionaryKey;
  flag: (typeof ProductFlagsDictionary)[ProductFlagDictionaryKey];
};

export function isProductFlagDictionaryKey(
  key: string,
): key is ProductFlagDictionaryKey {
  return Object.prototype.hasOwnProperty.call(ProductFlagsDictionary, key);
}

/**
 * Active product flags in stable iteration order (same as `Object.entries` on `flags`).
 * Ignores props that are not keys of `ProductFlagsDictionary` (e.g. `simple`, `withBullets`).
 */
export function resolveActiveProductFlags(
  flags: object,
): ResolvedProductFlag[] {
  return Object.entries(flags).flatMap(
    ([key, value]): ResolvedProductFlag[] => {
      if (!value || !isProductFlagDictionaryKey(key)) {
        return [];
      }
      return [{ key, flag: ProductFlagsDictionary[key] }];
    },
  );
}
